<template>
    <div>
        <div class="flex items-center justify-between mb-3">
            <div class="text-xs text-gray-500 dark:text-gray-400">
                Search status:
                <span class="font-medium" :class="statusClass">{{ statusLabel }}</span>
            </div>
            <button @click="reset" type="button"
                    class="text-xs text-gray-600 hover:text-gray-900 dark:text-gray-300 dark:hover:text-white underline">
                Clear
            </button>
        </div>

        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <!-- Column A: Broker sites -->
            <section class="border border-gray-200 dark:border-slate-700 rounded">
                <header class="px-4 py-2 bg-gray-50 dark:bg-slate-800 border-b border-gray-200 dark:border-slate-700">
                    <h2 class="text-sm font-semibold text-gray-800 dark:text-gray-100">Broker sites</h2>
                    <p class="text-xs text-gray-500 dark:text-gray-400">{{ totalListings(brokerSources) }} listings across {{ brokerSources.length }} sources</p>
                </header>
                <div v-if="brokerSources.length === 0" class="p-4 text-sm text-gray-500 dark:text-gray-400">
                    No brokerages selected.
                </div>
                <div v-else class="divide-y divide-gray-200 dark:divide-slate-700">
                    <div v-for="src in brokerSources" :key="src.brokerage_id || src.name" class="p-4">
                        <source-progress :source="src" />
                        <div v-if="src.listings.length === 0 && src.status === 'done'" class="mt-2 text-xs text-gray-500 dark:text-gray-400">
                            No listings matched the criteria.
                        </div>
                        <div class="mt-3 grid grid-cols-1 gap-2">
                            <listing-card v-for="(l, i) in src.listings" :key="src.name + ':' + i" :listing="l" />
                        </div>
                    </div>
                </div>
            </section>

            <!-- Column B: Firecrawl open web -->
            <section class="border border-gray-200 dark:border-slate-700 rounded">
                <header class="px-4 py-2 bg-gray-50 dark:bg-slate-800 border-b border-gray-200 dark:border-slate-700">
                    <h2 class="text-sm font-semibold text-gray-800 dark:text-gray-100">Firecrawl (open web)</h2>
                    <p class="text-xs text-gray-500 dark:text-gray-400">{{ totalListings(firecrawlSources) }} listings</p>
                </header>
                <div v-if="firecrawlSources.length === 0" class="p-4 text-sm text-gray-500 dark:text-gray-400">
                    Firecrawl open-web search not enabled for this run.
                </div>
                <div v-else class="divide-y divide-gray-200 dark:divide-slate-700">
                    <div v-for="src in firecrawlSources" :key="src.name" class="p-4">
                        <source-progress :source="src" />
                        <div v-if="src.listings.length === 0 && src.status === 'done'" class="mt-2 text-xs text-gray-500 dark:text-gray-400">
                            Firecrawl returned no usable hits for these criteria.
                        </div>
                        <div class="mt-3 grid grid-cols-1 gap-2">
                            <listing-card v-for="(l, i) in src.listings" :key="src.name + ':' + i" :listing="l" />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ResultsCompare',
    computed: {
        searchState()       { return this.$store.state.listingSearch.searchState; },
        brokerSources()     { return this.$store.getters.listingBrokerSources || []; },
        firecrawlSources()  { return this.$store.getters.listingFirecrawlSources || []; },
        statusLabel() {
            const s = this.searchState?.status;
            return ({ pending: 'Pending', running: 'Running', done: 'Complete', failed: 'Failed' })[s] || s || 'Unknown';
        },
        statusClass() {
            const s = this.searchState?.status;
            return {
                'text-yellow-600 dark:text-yellow-400': s === 'pending' || s === 'running',
                'text-green-600  dark:text-green-400':  s === 'done',
                'text-red-600    dark:text-red-400':    s === 'failed',
            };
        },
    },
    methods: {
        totalListings(sources) {
            return sources.reduce((acc, s) => acc + (s.listings?.length || 0), 0);
        },
        reset() {
            this.$store.commit('RESET_LISTING_SEARCH');
        },
    },
};
</script>
